module.exports = __webpack_public_path__ + "img/Stores.b7938af1.png";